export default { sha: '95a0d6288339dbf1fd97bdbdbbe788863afa53dc', buildNumber: 'undefined' }
